import script from "./CartPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartPage.vue?vue&type=script&setup=true&lang=ts"

import "./CartPage.vue?vue&type=style&index=0&id=d3faa826&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3faa826"]])

export default __exports__